<script>
import axios from "axios";
import RosterActualIndex from "./RosterActualIndex.vue";

export default {
  name: "RosterAiActualIndex",
  extends: RosterActualIndex,
  computed: {
    pageTitle() {
      return "Manage AI Actual Roster";
    },
    createButtonLabel() {
      return "Back to AI Schedule Roster";
    },
  },
  methods: {
    async loadRoster() {
      try {
        const { data } = await axios.get("/roster/aiactualindex", {
          params: { filter: this.filter },
          headers: { Authorization: "Bearer " + this.access_token, "Content-Type": "application/json" },
        });
        this.all_data = data.all_data || [];
      } catch (error) {
        console.log(error.response || error);
      }
    },
    goCreate() {
      this.$router.push("/roster/ai/index");
    },
    viewRoster(id) {
      this.$router.push("/roster/ai/actual/view?id=" + id);
    },
  },
};
</script>
